import { createContext, useState, useEffect } from 'react';
import api from '../utils/api';

const AccessCodeContext = createContext();

export const AccessCodeProvider = ({ children }) => {
  const [isVerified, setIsVerified] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Check if code is already verified on initial render
  useEffect(() => {
    const checkVerification = async () => {
      try {
        // First check localStorage
        const verificationStatus = localStorage.getItem('accessCodeVerified');
        
        if (verificationStatus === 'true') {
          // Double-check with the server that the verification is still valid
          try {
            // This is just to validate that the API is working
            await api.get('/api/access-code');
            setIsVerified(true);
          } catch (err) {
            // If API call fails, reset verification status
            console.error('API verification failed:', err);
            localStorage.removeItem('accessCodeVerified');
            setIsVerified(false);
          }
        } else {
          // Force verification if not verified
          setIsVerified(false);
        }
      } catch (err) {
        console.error('Error checking verification:', err);
        setIsVerified(false);
      } finally {
        setLoading(false);
      }
    };
    
    checkVerification();
  }, []);

  // Verify access code
  const verifyCode = async (code) => {
    setError(null);
    
    try {
      console.log('Sending verification request with code:', code);
      const res = await api.post('/api/access-code/verify', { code });
      console.log('Verification response:', res.data);
      
      if (res.data.success) {
        setIsVerified(true);
        localStorage.setItem('accessCodeVerified', 'true');
        return { success: true };
      }
    } catch (err) {
      console.error('Verification error details:', err.response?.data);
      const errorMessage = err.response?.data?.msg || 'Invalid access code';
      setError(errorMessage);
      return { success: false, error: errorMessage };
    }
  };

  // Reset verification (for testing purposes)
  const resetVerification = () => {
    localStorage.removeItem('accessCodeVerified');
    setIsVerified(false);
  };

  return (
    <AccessCodeContext.Provider
      value={{
        isVerified,
        loading,
        error,
        verifyCode,
        resetVerification
      }}
    >
      {children}
    </AccessCodeContext.Provider>
  );
};

export default AccessCodeContext;
